import { Card } from 'antd';

/**
 * Барааны дэлгэцүүдийн хэсгүүдийг нэг ижил харагдацтай болгох бүрхүүл.
 * Бусад дэлгэц (Барааны дэлгэрэнгүй, Хүргэлт үүсгэх)-тэй ижил
 * `Card size="middle"` + зүүн талд дүрстэй гарчиг.
 */
const SectionCard = ({ icon, title, action, children, ...cardProps }) => (
  <Card
    size="middle"
    title={
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
        {icon}
        {title}
      </span>
    }
    extra={action}
    {...cardProps}
  >
    {children}
  </Card>
);

export default SectionCard;
